// Get all reveal cards
document.addEventListener('DOMContentLoaded', () => {
  const revealCards = document.querySelectorAll('.reveal-card');

  revealCards.forEach((card) => {
    card.addEventListener('click', function () {
      // If this card is already active, just remove its active class
      if (card.classList.contains('active')) {
        card.classList.remove('active');
        return;
      }

      // Remove active class from all cards
      revealCards.forEach((otherCard) => {
        otherCard.classList.remove('active');
      });

      // Add active class to clicked card
      card.classList.add('active');
    });
  });
});
